import React, {Component} from 'react';
import './App.css';
import About from './about/About';
import Order from './order/Order';
import {Link} from 'react-scroll';
import * as Headroom from 'headroom.js';
import Home from './home/Home';


class App extends Component {

    sideNav;

    resize = () => this.forceUpdate();

    componentDidMount() {
        let menuElement = document.getElementById('menu-button-container');
        menuElement.onclick = () => this.openNav();

        let headroomElement = document.getElementById('app-header');
        let headroom = new Headroom(headroomElement, {
            offset: 500,
            tolerance: 10
        });
        headroom.init();


        window.addEventListener('resize', this.resize);
    }

    openNav() {
        this.sideNav.classList.toggle('extended');
        document.getElementById('menu-button-container').classList.toggle('change');
    }

    closeNav() {
        this.sideNav.classList.remove('extended');
        document.getElementById('menu-button-container').classList.remove('change');
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    render() {
        let height = isNaN(window.innerHeight) ? window.clientHeight : window.innerHeight;
        return (
            <div className="app-container">

                <a className="symbol bottom-reveal" id="facebook" href="https://facebook.com/taltechfilmiklubi" target="_blank">
                    circlefacebook</a>
                <a className="symbol bottom-reveal" id="instagram" href="https://www.instagram.com/taltechfilmiklubi" target="_blank">
                    circleinstagram</a>
                <a className="symbol bottom-reveal" id="youtube" href="https://www.youtube.com/channel/UC28tRFC9IZItoC2aV1-kd6w" target="_blank">
                    circleyoutube</a>


                <header id="home-header" className="header-reveal">
                    <div className="home-topnav">
                        <Link spy={false} smooth={true} activeClass="active" to="home">Avaleht</Link>
                        <Link spy={false} smooth={true} activeClass="active" to="about">Meist</Link>
                        <Link spy={false} smooth={true} activeClass="active" to="order">Kontakt</Link>
                    </div>
                </header>
                <header id="app-header">
                    <div className="topnav">
                        <Link spy={false} smooth={true} activeClass="active" to="home">Avaleht</Link>
                        <Link spy={false} smooth={true} activeClass="active" to="about">Meist</Link>
                        <Link spy={false} smooth={true} activeClass="active" to="order">Kontakt</Link>
                    </div>
                    <div id="indicator-border"/>
                </header>

                <div ref={e => this.sideNav = e} className="sidenav">
                    <Link spy={false} smooth={true} activeClass="active" to="home" onClick={() => this.closeNav()}>Avaleht</Link>
                    <Link spy={false} smooth={true} activeClass="active" to="about" onClick={() => this.closeNav()}>Meist</Link>
                    <Link spy={false} smooth={true} activeClass="active" to="order" onClick={() => this.closeNav()}>Kontakt</Link>
                </div>

                <div className="menu-button-container header-reveal" id="menu-button-container">
                    <div className="menu-button-line-container">
                        <div className="bar1"/>
                        <div className="bar2"/>
                        <div className="bar3"/>
                    </div>
                </div>


                <section style={{height: height}} className="section section1" id="home" ref="Home"><Home/></section>
                <section style={{height: 'auto'}} className="section section4" id="about" ref="About"><About/></section>
                <section style={{height: height}} className="section section6" id="order" ref="Order"><Order/></section>
            </div>
        );
        // <Element style={{height: 'auto'}} className="section section5" name="Portfolio"><Portfolio/></Element>
        // <Link spy={false} smooth={true} activeClass="active" to="Portfolio" onClick={() => this.closeNav()}>Portfolio</Link>
        // <Link spy={false} smooth={true} activeClass="active" to="Portfolio">Portfolio</Link>
        // <Link spy={false} smooth={true} activeClass="active" to="Portfolio">Portfolio</Link>
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js